import { gql } from "@apollo/client";import { useMutation } from "@apollo/client/react";import React from 'react';
import { Fade, MenuItem, styled } from "@mui/material";
import moment from 'moment';

import { useNavigate } from 'react-router-dom';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useEffect, useContext } from 'react';
import { useState } from 'react';
import ErrorDialog from '../../../../../components/ErrorDialog';
import { NotificacionContext } from '../../../../../context/NotificacionContext';


const Notificacion = ({ mensaje, refrescarRegistros, handleClose }) => {

  const ESTADO_LEIDO = 1;

  const { countNotificacionesNoLeidas, setCountNotificacionesNoLeidas } = useContext(NotificacionContext);

  // Log de errores
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  const navigate = useNavigate();

  const MSaveNotificacionEstado = gql`
    mutation MSaveNotificacionEstado ($idNotificacion: Long!, $estado: Int!) {
        saveNotificacionEstado
        (
            idNotificacion: $idNotificacion,
            estado: $estado
        )
        {
            success,
            error,
            valorEsperado
        }
    }`;

  const [marcarLectura, { data }] = useMutation(MSaveNotificacionEstado, {
    onCompleted: (data) => {
      if (data.saveNotificacionEstado.success) {
        refrescarRegistros();
        handleClose(this, mensaje.comentario);
        if (mensaje.link !== '') {
          navigate(mensaje.link);
        }
        setCountNotificacionesNoLeidas(countNotificacionesNoLeidas > 0 ? countNotificacionesNoLeidas - 1 : 0);
      } else {
        setMensajeError(data.saveNotificacionEstado.error);
      }
    },
    onError: (data) => {
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const handleClickLeido = (e) => {
    marcarLectura({ variables: { idNotificacion: mensaje.idNotificacion, estado: ESTADO_LEIDO } });
  };

  const HtmlTooltip = styled(({ className, ...props }) =>
  <Tooltip {...props} classes={{ popper: className }} />
  )(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#868686',
      color: 'white',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(14),
      border: '1px solid #868686'
    }
  }));

  return (
    <>
        <MenuItem
        key={mensaje.idNotificacion}
        onClick={handleClickLeido}
        style={{ fontSize: 13, width: '100%' }}>
              
            <HtmlTooltip
          arrow
          placement='left'
          title={mensaje.comentario ? mensaje.comentario : ""}
          TransitionComponent={Fade}
          TransitionProps={{ timeout: 600 }}>
          
                <div style={{
            backgroundColor: '#E2EEFE',
            border: '1pt solid #E2EEFE',
            borderRadius: 10,
            padding: 5,
            width: mensaje.comentario ? "96%" : "100%"
          }}>
                    <div style={{ display: 'flex', fontSize: '1em', padding: 2, width: '100%' }}>
                        <div style={{ width: '95%' }}><strong>{mensaje.titulo}</strong></div>
                        <div style={{ fontSize: '0.8em', paddingRight: 5 }}>{moment(mensaje.fechaAlta).format("DD/MM/YYYY HH:mm:ss")}</div>
                    </div>
                    <div style={{ fontSize: '0.9em', color: '#777878', padding: 2, flex: 1, overflow: 'hidden', whiteSpace: 'wrap' }}>
                        {mensaje.descripcion}
                    </div>                
                    <div
              style={{ fontSize: '0.9em', padding: 2, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              
                        <i>{mensaje.comentario ? mensaje.comentario : "-"}</i>
                    </div>                
                </div>
            </HtmlTooltip>     
        </MenuItem>
        <ErrorDialog
        id="dlg-error-save-notificacion"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />
      
        </>);

};

export default Notificacion;